import { createSlice } from '@reduxjs/toolkit';
import { AppThunk } from './store';
import { apiString as API_URL } from '../utils/constants';
import axios from 'axios';
import b64toBlob from 'b64-to-blob';
import { setIsLoading, setDownLoading } from './shared.slice';
import { dateFormatter } from '../utils/timeFormat';
import { SdohAssessment } from '../Models/Sdoh/SdohAssessment.model';

const sdohAssessmentsRequests = createSlice({
    name: 'sdohAssessmentsRequests',
    initialState: {
        startDate: new Date(),
        endDate: new Date(),
        reportType: '',
        rowData: [],
    },
    reducers: {
        _setStartDate(state, action) {
            state.startDate = action.payload;
        },
        _setEndDate(state, action) {
            state.endDate = action.payload;
        },
        _setReportType(state, action) {
            state.reportType = action.payload;
        },
        _setRowData(state, action) {
            state.rowData = action.payload;
        },
    },
});

const { _setStartDate, _setEndDate, _setReportType, _setRowData } = sdohAssessmentsRequests.actions;

export const setStartDate =
    (params: Date): AppThunk =>
    async (dispatch) => {
        dispatch(_setStartDate(params));
    };

export const setEndDate =
    (params: Date): AppThunk =>
    async (dispatch) => {
        dispatch(_setEndDate(params));
    };

export const setReportType =
    (params: string): AppThunk =>
    async (dispatch) => {
        dispatch(_setReportType(params));
    };

export const setRowData =
    (params: []): AppThunk =>
    async (dispatch) => {
        dispatch(_setRowData(params));
    };

export const fetchSDOHReports =
    (route: string, start: Date, end: Date): AppThunk =>
    async (dispatch) => {
        try {
            dispatch(setIsLoading(true));
            const response = await axios.get(`${API_URL}/assessment/get${route}&startDate=${dateFormatter(start)}&endDate=${dateFormatter(end)}`);
            dispatch(setRowData(response.data));
            dispatch(setIsLoading(false));
        } catch (error) {
            dispatch(setRowData([]));
            dispatch(setIsLoading(false));
        }
    };

export const exportSDOHReports =
    (route: string, start: Date, end: Date): AppThunk =>
    async (dispatch) => {
        dispatch(setDownLoading(true));
        const response = await axios.get(`${API_URL}/assessment/export${route}&startDate=${dateFormatter(start)}&endDate=${dateFormatter(end)}`);
        let blob = b64toBlob(response.data.base64String, 'text/csv');
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${Date.now()}.xlsx`);
        link.click();
        link.remove();
        dispatch(setDownLoading(false));
    };

export const updateSdohAssessmentRequests =
    (sdohAssessment: SdohAssessment): AppThunk =>
    async (dispatch) => {
        await axios.put(`${API_URL}/assessment/updatesdohassessmentrequests`, sdohAssessment);
    };

export default sdohAssessmentsRequests.reducer;
